import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class IGiaoDucCourseDetailAPI extends BaseAPI {}

export default new IGiaoDucCourseDetailAPI('v1/igiaoduc-course-detail', 'CourseDetail')
